module.exports = __webpack_public_path__ + "images/root/mainVisual_products_right_pc_f6dd36d492b12b5956d0f83dbedc837f.svg";